import { useEffect } from 'react';

import { isBankMessageUnread } from '../BankMessagesService';
import { useMarkBankMessageAsRead } from '../useBankMessages';
import { invalidateUnreadBankMessages } from '../useUnreadBankMessages';
import type { BankMessage } from '../BankMessagesTypes';

export const useAutoMarkBankMessageRead = (message: BankMessage | undefined) => {
    const { updateById: markMessageAsRead } = useMarkBankMessageAsRead();

    useEffect(() => {
        if (!message || !isBankMessageUnread(message.flags)) {
            return;
        }

        markMessageAsRead({ id: message.id, changes: message })
            .then(() => {
                invalidateUnreadBankMessages();
            })
            .catch(() => {});
    }, [markMessageAsRead, message]);
};
